import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { Services } from "./components/site/Services";
import { WeComeToYou } from "./components/site/WeComeToYou";
import { Areas } from "./components/site/Areas";
import { Seniors } from "./components/site/Seniors";
import { Business } from "./components/site/Business";
import { About } from "./components/site/About";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { StickyCallButton } from "./components/site/StickyCallButton";
import Pricing from "./pages/Pricing";

const Home = () => {
    useEffect(() => {
        document.title = "Computer Repairs Semaphore | Onsite Computer Help";
        if (window.location.hash) {
            const el = document.querySelector(window.location.hash);
            if (el) setTimeout(() => el.scrollIntoView(), 100);
        }
    }, []);
    return (
        <main>
            <Hero />
            <WeComeToYou />
            <Services />
            <Areas />
            <Seniors />
            <Business />
            <About />
            <Contact />
        </main>
    );
};

export default function App() {
    return (
        <BrowserRouter>
            <div className="min-h-screen bg-white" data-testid="app-root">
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/pricing" element={<Pricing />} />
                </Routes>
                <Footer />
                <StickyCallButton />
                <Toaster position="top-center" richColors />
            </div>
        </BrowserRouter>
    );
}
